<style>
  .errorText {
    color: red
  }
  .button.large {
      padding-right: 4.55rem;
      margin-left: 0.5rem;
  }
</style>
<template>
  <div class="modal-window large split active">
    <overlay-scrollbars
      :options="{ className: 'custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
      <form @submit.prevent="handleSubmit">
        <div class="grid-x split">
          <div class="cell large-6 flex-column">
            <div class="modal-window-header gray">
              <div class="modal-window-heading">
                <h3 class="icon-heading small">
                  <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use
                    xlink:href="/static/sprites.svg#button-glyph-object"></use></svg></span>
                  <span class="icon-heading-title">
                    <span class="title">Opprett faktura</span>
                    <span class="subtitle">Faktura</span>
                  </span>
                </h3>
              </div>
            </div>

            <div class="modal-window-body">
              <fieldset>
                <div class="grid-x grid-padding-x">
                  <div class="cell medium-12">
                    <template v-if="isAccounting">
                      <label for="Fakturadato">Fakturadato</label>
                      <div class="input-container">
                        <b-datepicker
                          :show-week-number="false"
                          :editable="false"
                          :first-day-of-week="1"
                          v-model="form.Fakturadato"
                          name="Fakturadato"
                          placeholder="Vis kalender..."
                          icon="calendar-today"
                          ref="Fakturadato"
                          id="Fakturadato">
                          <button class="button disabled" v-if="!form.Fakturadato"
                                  @click.prevent="$refs.Fakturadato.toggle()"><span>Slett dato</span></button>
                          <button class="button" v-else @click.prevent="form.Fakturadato = null"><span>Slett dato</span>
                          </button>
                        </b-datepicker>
                        <span class="glyph"><svg viewBox="0 0 44 44"><use
                          xlink:href="/static/sprites.svg#glyph-input-date"></use></svg></span>
                      </div>
                    </template>

                    <label for="Forfallsdato">Forfallsdato</label>
                    <div class="input-container">
                      <b-datepicker
                        :show-week-number="false"
                        :editable="false"
                        :first-day-of-week="1"
                        :min-date="minDate"
                        v-model="form.Forfallsdato"
                        name="Forfallsdato"
                        placeholder="Vis kalender..."
                        icon="calendar-today"
                        ref="Forfallsdato"
                        id="Forfallsdato">
                        <button class="button disabled" v-if="!form.Forfallsdato"
                                @click.prevent="$refs.Forfallsdato.toggle()"><span>Slett dato</span></button>
                        <button class="button" v-else @click.prevent="form.Forfallsdato = null"><span>Slett dato</span>
                        </button>
                      </b-datepicker>
                      <span class="glyph"><svg viewBox="0 0 44 44"><use
                        xlink:href="/static/sprites.svg#glyph-input-date"></use></svg></span>
                    </div>
                  </div>

                  <TheSelectInput containerClassName="cell medium-12" label="Betalingsmetode" name="PaymentMethod"
                                  required v-validate="'required'" data-vv-validate-on="input"
                                  v-model="form.PaymentMethod" :items="paymentMethodsDropdown">
                   <span slot="option" slot-scope="props">
                     {{props.option.label}}
                   </span>
                  </TheSelectInput>
                </div>
              </fieldset>
            </div>

            <div class="modal-window-footer">
              <div class="grid-x">
                <div class="cell medium-2">
                  <a v-if="!$store.getters.isFormProcessing" href="javascript:;" @click="closeButtonClick()"
                      class="button primary transparent large modal-close show-for-medium">Avbryt</a>
                  <a v-else href="javascript:;" class="button primary transparent large modal-close show-for-medium">Avbryt</a>
                </div>
                <div class="cell medium-10">
                  <template>
                    <div>
                      <a v-if="$store.getters.isFormSubmittable" href="javascript:;" @click="submitButtonAndDliverClick()"
                          class="button primary submit large">Opprett faktura og utlever</a>
                      <a v-if="$store.getters.isFormLoading" href="javascript:;" class="button primary submit large"
                          disabled>Opprett faktura og utlever</a>
                      <a v-if="$store.getters.isFormProcessing && deliverButton" href="javascript:;"
                          class="button primary submit large loading">Opprett faktura og utleverer...<span
                        class="loader-spinner"></span></a>
                      <a v-if="$store.getters.isFormProcessing && !deliverButton" href="javascript:;" class="button primary submit large"
                          disabled>Opprett faktura og utlever</a>
                    </div>

                    <div>
                      <a v-if="$store.getters.isFormSubmittable" href="javascript:;" @click="submitButtonClick()"
                          class="button primary submit large">Opprett faktura</a>
                      <a v-if="$store.getters.isFormLoading" href="javascript:;" class="button primary submit large"
                          disabled>Opprett faktura</a>
                      <a v-if="$store.getters.isFormProcessing && !deliverButton" href="javascript:;"
                          class="button primary submit large loading">Oppretter faktura...<span
                        class="loader-spinner"></span></a>
                      <a v-if="$store.getters.isFormProcessing && deliverButton" href="javascript:;" class="button primary submit large"
                          disabled>Opprett faktura</a>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>

          <div class="cell large-6 flex-column">
            <div class="modal-window-body">
              <template v-if="form.objektdata.Mottaker.Kundenr">
                <div class="grid-x grid-padding-x">
                  <div class="cell medium-12">
                    <h3>Kunde: {{form.objektdata.Mottaker.full_name}}</h3>
                  </div>
                </div>
                <div class="grid-x grid-padding-x">
                  <div class="cell medium-12">&nbsp;</div>
                </div>

                <div class="grid-x grid-padding-x" v-bind:class="{errorText: !invoiceAddress}">
                  <div class="cell medium-9">
                    Fakturadresse
                  </div>
                  <div class="cell medium-3 align-right">
                    <span v-if="invoiceAddress">Ok</span>
                    <span v-else style="font-size:0.6em;">Adresse mangler</span>
                  </div>
                  <div class="cell medium-12">
                    {{form.objektdata.Mottaker.full_address_fak}}
                  </div>
                </div>
                <div class="grid-x grid-padding-x">
                  <div class="cell medium-12">&nbsp;</div>
                </div>

                <div class="grid-x grid-padding-x" v-bind:class="{errorText: !postAddress}">
                  <div class="cell medium-9">
                    Leveringsadresse
                  </div>
                  <div class="cell medium-3 align-right">
                    <span v-if="postAddress">Ok</span>
                    <span v-else style="font-size:0.6em;">Adresse mangler</span>
                  </div>
                  <div class="cell medium-12">
                    {{form.objektdata.Mottaker.full_address_lev}}
                  </div>
                </div>
                <div class="grid-x grid-padding-x">
                  <div class="cell medium-12">&nbsp;</div>
                </div>

                <div class="grid-x grid-padding-x">
                  <div class="cell medium-12">&nbsp;</div>
                </div>

                <div class="grid-x grid-padding-x">
                  <div class="cell medium-12">
                    <a href="javascript:;" @click="openKundeModal()">Rediger kjøper</a>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>

        <a href="javascript:;" class="modal-close modal-window-close-button" @click="closeButtonClick()">
          <span>Lukk</span>
          <svg width="16px" height="16px" viewBox="0 0 16 16">
            <use xlink:href="/static/sprites.svg#button-glyph-close"></use>
          </svg>
        </a>
      </form>
    </overlay-scrollbars>
  </div>
</template>

<script>
import AuksjonService from '@/services/AuksjonService'
import KundeService from '@/services/KundeService'
import TheAutoCompleteInput from '../Inputs/TheAutoCompleteInput'
import bus from '@/plugins/event-bus'
import moment from 'moment'
import {getPaymentMethodsDropdown} from '../../helpers/Constants'

export default {
  name: 'MultiInvoiceModal',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    TheAutoCompleteInput
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    objektlist: {
      type: Array,
      required: true
    }
  },
  data () {
    const today = new Date()

    return {
      form: {
        Fakturadato: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
        Forfallsdato: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 10),
        PaymentMethod: null,
        objektdata: {
          Auksjon: null,
          Mottaker: null
        }
      },
      // minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
      uhDropdown: [],
      typeGroupDropdown: [],
      paymentMethodsDropdown: getPaymentMethodsDropdown(),
      loaded: 0,
      deliverButton: null
    }
  },
  created () {
    bus.$off('kunde-address-updated')
    this.setup()
    this.fetch()
  },
  mounted () {
    bus.$on('kunde-address-updated', (data) => this.onKundeAddressUpdated(data))
  },
  watch: {
    loaded: function (newVal) {
      if (newVal === 2) {
        this.setFormLoading(false)
      }
    }
  },
  computed: {
    isAccounting: function () {
      return this.hasAccess('accounting')
    },
    minDate: function () {
      const today = new Date()

      return this.isAccounting ? null : new Date(today.getFullYear(), today.getMonth(), today.getDate())
    },
    invoiceAddress: function () {
      if (!this.form.objektdata.Mottaker) {
        return null
      }

      if (!this.form.objektdata.Mottaker.kundeadresse || this.form.objektdata.Mottaker.kundeadresse.length < 1) {
        return null
      }

      return this.form.objektdata.Mottaker.kundeadresse.filter(i => i.Type === 'faktura')
    },
    postAddress: function () {
      if (!this.form.objektdata.Mottaker) {
        return null
      }

      if (!this.form.objektdata.Mottaker.kundeadresse || this.form.objektdata.Mottaker.kundeadresse.length < 1) {
        return null
      }

      return this.form.objektdata.Mottaker.kundeadresse.filter(i => i.Type === 'levering')
    },
    accountNumber: function () {
      if (!this.form.objektdata.Mottaker) {
        return null
      }

      if (this.form.objektdata.Mottaker.Kontonr && this.form.objektdata.Mottaker.Kontonr !== '') {
        if (!this.form.objektdata.Mottaker.Kontonr.match(/^\d+$/)) {
          return null
        }
        if (!this.form.objektdata.Mottaker.Kontonr.length === 11) {
          return null
        }
      }

      return this.form.objektdata.Mottaker.Kontonr
    },
    isValidForSave: function () {
      if (!this.form.objektdata.Mottaker.Kundenr) {
        return false
      }
      if (!this.invoiceAddress || !this.postAddress) {
        return false
      }

      return true
    }
  },
  methods: {
    setup: function () {
      this.form.objektdata = this._.clone(this.data.objektdata)
      this.form.objektdata.Salgspris = 0.00
      this.form.objektdata.Auksjon = null
    },
    fetch: function () {
      // Load dropdown for AR auksjon, based on kontrakt->avdeling
      this.uhDropdown = []
      this.uhDropdown.push({key: null, val: 'Laster...'})
      AuksjonService.latestUnderhand()
        .then((response) => {
          this.uhDropdown = []
          this.uhDropdown.push({key: this.form.objektdata.Auksjon, val: 'Velg auksjon', disabled: true})

          response.data.forEach((x) => {
            // Make first item selected
            if (!this.form.objektdata.Auksjon) {
              this.form.objektdata.Auksjon = x.Auksjon
            }

            this.uhDropdown.push({key: x.Auksjon, val: x.Beskrivelse})
          })
        })
        .catch((e) => {
          console.log(e)
        })
        .then(() => {
          ++this.loaded
        })

        // Load type groups
      this.typeGroupDropdown = []
      this.typeGroupDropdown.push({key: null, val: 'Laster...'})
    },
    onKundeAddressUpdated: function (data) {
      this.$helpers.showSuccessAlert('Kunde addresse er lagret')

      this.form.objektdata.Mottaker = data

      bus.$emit('bilag-kunde-updated', data)
    },
    openKundeModal: function () {
      this.openModal(
        'kunde-adresse-modal',
        {
          kunde: this.form.objektdata.Mottaker,
          event: 'kunde-address-updated'
        }
      )
    },
    closeButtonClick: function () {
      if (!this.$store.getters.isFormProcessing) {
        this.$emit('close')
      }
    },
    submitButtonAndDliverClick: function () {
      this.handleSubmit(true)
    },
    submitButtonClick: function () {
      this.handleSubmit()
    },
    makePostData: function () {
      let omitInLine = [
        'Bilagslinjeid',
        'Bilagsid',
        'Linjenr',
        'Utlevdato',
        'twentyfourseven_id',
        'Internalid',
        'Internaledit',
        'Internaldel',
        'Internalincmva',
        'Objektid',
        'Enhetskode',
        'Hbversion',
        'eurokurs'
      ]

      let retval = {
        Fakturadato: this.isAccounting && this.form.Fakturadato ? moment(new Date(Date.parse(this.form.Fakturadato))).format('YYYY-MM-DD 00:00:00') : null,
        Forfallsdato: this.form.Forfallsdato ? moment(new Date(Date.parse(this.form.Forfallsdato))).format('YYYY-MM-DD 00:00:00') : null,
        PaymentMethod: this.form.PaymentMethod,
        Bilagstype: this.data.Bilagstype,
        Export: this.data.Export,
        Mvafri: this.data.Mvafri,
        Retur: this.data.Retur,
        type: this.data.type,
        objektdata: {
          Mottaker: this.data.objektdata.Mottaker.Kundenr,
          Auksjon: this.form.objektdata.Auksjon
        }
      }

      retval.objektlist = []
      this.objektlist.forEach((obj) => {
        let lines = []

        obj.bilag_draft.bilagslinje.forEach((line) => {
          lines.push(this._.omit(line, omitInLine))
        })

        let item = {
          Objekt: obj.Objektid,
          bilaglines: lines
        }

        retval.objektlist.push(item)
      })

      return retval
    },
    openBilagPdfModal: function (bilag) {
      const vm = this

      // Close current modal...
      this.closeModal()

      bus.$emit('hide-kontrakt-invoice-ar')
      bus.$emit('before-leave-page')

      // Shall we run these here?
      /*
      this.$store.dispatch('kundeobjektbuyerinvoice/load', vm.data.objektdata.Mottaker.Kundenr)
      this.$store.dispatch('kundeobjektbuyer/load', vm.data.objektdata.Mottaker.Kundenr)
      this.$store.dispatch('kundeobjektseller/load', vm.data.objektdata.Mottaker.Kundenr)
      this.$store.dispatch('kundeobjektdeliver/load', vm.data.objektdata.Mottaker.Kundenr)
      this.$store.dispatch('kundebilag/load', vm.data.objektdata.Mottaker.Kundenr)
      */

      this.$router.push({
        path: '/searchredirect',
        query: {
          kunde_id: this.data.objektdata.Mottaker.Kundenr
        },
        hash: ''
      }, function () {
        // On complete
        bus.$emit('ar-invoiced')

        if (vm.form.PaymentMethod === 'none') {
          // ...and open send email with pdf modal
          vm.openModal('bilag-email-pdf-modal',
            { query: bilag, internalWindow: true },
            'split'
          )
        }
      })
    },
    handleSubmit: function (utlever = false) {
      var vm = this
      if (!this.isFormSubmittable()) {
        return
      }

      this.deliverButton = utlever

      this.setFormProcessing(true)

      setTimeout(function () {
        vm.$validator.validateAll()
          .then((result) => {
            if (!result) {
              // Validation Failed
              console.log('Validation Failed')
              if (vm.invoiceAddress == null) {
                vm.$helpers.showErrorAlert('Feil', 'Kjøper mangler fakturaddresse.')
              } else if (vm.postAddress == null) {
                vm.$helpers.showErrorAlert('Feil', 'Kjøper mangler leveringsadresse.')
              } else if (vm.form.PaymentMethod == null) {
                vm.$helpers.showErrorAlert('Feil', 'Du må velge betalingsmetode.')
              } else {
                vm.$helpers.showErrorAlert('Feil', 'Vennligst korriger feil')
              }

              setTimeout(function () {
                vm.setFormProcessing(false)
              }, 750)
            } else if (!vm.isValidForSave) {
              console.log('Is valid for save', vm.makePostData())
              vm.$helpers.showErrorAlert('Feil', 'Vennligst korriger feil')

              setTimeout(function () {
                vm.setFormProcessing(false)
              }, 750)
            } else {
              // Prepare post data and send
              let post = vm.makePostData()
              post.utlever = utlever
              KundeService.saveInvoices(vm.form.objektdata.Mottaker.Kundenr, post)
                .then((response) => {
                  console.log('Save Invoices')
                  console.log(response)
                  vm.openBilagPdfModal(response.data.bilag || null)
                  // // Close modal
                  // vm.$emit('close')
                  // bus.$emit('hide-kontrakt-invoice-ar')
                  // bus.$emit('before-leave-page')

                  // // Shall we run these here?
                  // /*
                  // this.$store.dispatch('kundeobjektbuyerinvoice/load', vm.data.objektdata.Mottaker.Kundenr)
                  // this.$store.dispatch('kundeobjektbuyer/load', vm.data.objektdata.Mottaker.Kundenr)
                  // this.$store.dispatch('kundeobjektseller/load', vm.data.objektdata.Mottaker.Kundenr)
                  // this.$store.dispatch('kundeobjektdeliver/load', vm.data.objektdata.Mottaker.Kundenr)
                  // this.$store.dispatch('kundebilag/load', vm.data.objektdata.Mottaker.Kundenr)
                  // */

                  // vm.$router.push({
                  //   path: '/searchredirect',
                  //   query: {
                  //     kunde_id: vm.data.objektdata.Mottaker.Kundenr
                  //   },
                  //   hash: ''
                  // }, bus.$emit('ar-invoiced'))
                })
                .catch((error) => {
                  console.log('Error From API', error)

                  // See if we have 247 error
                  const twentyfourSevenError = vm.$helpers.getTwentyfourSevenError(error)

                  if (twentyfourSevenError) {
                    vm.$helpers.showErrorAlert('Kunne ikke lagre faktura', twentyfourSevenError)
                  } else {
                    vm.$helpers.sendApiErrorsToValidator(error, vm.errors)

                    // Check if new errors appeared
                    if (vm.errors.any()) {
                      vm.$validator.resume()
                      vm.$helpers.showErrorAlert('Kunne ikke lagre faktura', 'Vennligst korriger feil i skjemaet')
                    } else {
                      vm.$helpers.showErrorAlert('Kunne ikke lagre faktura', 'Vennligst prøv igjen', 2500)
                    }
                  }
                })
                .then(() => {
                  vm.setFormProcessing(false)
                })
            }
          })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/MultiInvoiceModal.vue